window.addEventListener("load", () => {
  const container = document.querySelector(".parallax-container");
  const back = document.querySelector(".layer.back");
  const front = document.querySelector(".layer.front");

  if (!container || !back || !front) {
    return;
  }

  container.addEventListener("mousemove", (e) => {
    const { width, height } = container.getBoundingClientRect();
    const offsetX = (e.clientX / width - 0.5) * 2;
    const offsetY = (e.clientY / height - 0.5) * 2;

    back.style.transform = `translate(${offsetX * 10}px, ${offsetY * 10}px)`;
    // front.style.transform = `translate(${offsetX * 20}px, ${offsetY * 20}px)`;
  });
});
